console.log('view.js loaded');

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.cancan-foods-slider')
    .forEach(initSlider);
});

function initSlider(container) {
  if (!container || container.swiper) return;

  const wrapper = container.parentElement;

  new Swiper(container, {
    spaceBetween: 29,       
    slidesPerView: 1,        
    loop: false,              
    centeredSlides: false,     
    watchOverflow: true,

    navigation: {
      nextEl: wrapper.querySelector('.swiper-button-next'),
      prevEl: wrapper.querySelector('.swiper-button-prev'),
    },

    breakpoints: {
      640: { slidesPerView: 1, spaceBetween: 15 },
      768: { slidesPerView: 2, spaceBetween: 20 },
      1124: { slidesPerView: 3, spaceBetween: 25 },
      1524: { slidesPerView: 4, spaceBetween: 29 },
    },
  });

}
